import { Box, Center } from "@chakra-ui/react"
import Icon from "components/UI/atoms/Icon"

import { IIconButtonProps } from "./IconButtonTypes"

const IconButton: React.FC<IIconButtonProps> = ({
  iconName,
  onClick,
  variant = "rounded",
  size = "base",
  iconStyles = { fill: "#7D90A8", width: "16px", height: "16px" }
}) => {
  let styles = {}

  if (variant === "rounded") {
    styles = {
      ...styles,
      borderRadius: "50%",
      border: "1px solid",
      borderColor: "icon_button_border_color",
    }
  }

  if (variant === "solid") {
    styles = {
      ...styles,
      borderRadius: "8px",
      backgroundColor: "#fff",
    }
  }

  if (size === "base") {
    styles = {
      ...styles,
      width: "31px",
      height: "31px",
    }
  }

  return (
    <Box {...styles}>
      <Center height="100%">
        <Box as="button" onClick={onClick}>
          <Icon
            name={iconName}
            iconStyles={iconStyles}
          />
        </Box>
      </Center>
    </Box>
  )
}

export default IconButton
